import { render, staticRenderFns } from "./OrderIndexModal.vue?vue&type=template&id=4055251d&scoped=true&"
import script from "./OrderIndexModal.vue?vue&type=script&lang=js&"
export * from "./OrderIndexModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderIndexModal.vue?vue&type=style&index=0&id=4055251d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055251d",
  null
  
)

export default component.exports